export const VEHICLE_SELECTION_MODES = {
  allVehicles: 'allVehicles',
  vehicleGroup: 'vehicleGroup',
  selectedVehicles: 'selectedVehicles',
}

export const QUESTION_TYPES = {
  options: 'RadioButton',
  text: 'TextBox',
}

export const SUPPORTIVE_EVIDENCE_POLICIES = {
  optional: 'Optional',
  required: 'Required',
  requiredOnUnhealthy: 'RequiredOnUnhealthy',
}

export const SUPPORTIVE_EVIDENCE_POLICY_OPTIONS = [
  {
    value: SUPPORTIVE_EVIDENCE_POLICIES.optional,
    label: 'vehicleInspection.form.supportiveEvidencePolicyOptions.optional',
  },
  {
    value: SUPPORTIVE_EVIDENCE_POLICIES.required,
    label: 'vehicleInspection.form.supportiveEvidencePolicyOptions.required',
  },
  {
    value: SUPPORTIVE_EVIDENCE_POLICIES.requiredOnUnhealthy,
    label: 'vehicleInspection.form.supportiveEvidencePolicyOptions.requiredOnUnhealthy',
  },
]

export const QUESTION_TYPE_OPTIONS = [
  {
    label: 'vehicleInspection.fields.options',
    value: QUESTION_TYPES.options,
    icon: 'icon-fill_radio-button-on',
  },
  {
    label: 'vehicleInspection.fields.text',
    value: QUESTION_TYPES.text,
    icon: 'icon-fill_text',
  },
]

export const DEFAULT_ANSWER_OPTIONS = [
  { label: 'global.no', value: false },
  { label: 'global.yes', value: true },
]
